import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { attendanceSheetCsv15opd55ow0c0p as attendanceSheetCsv } from './attendanceSheet.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { toBlob3efqyqa0phgb9 as toBlob } from '../../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { download3e9i5zj8k9dp8 as download } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  get_bold3d63kt1t4c9r5 as get_bold,
  themed2vu67ornd4jps as themed,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import {
  ID14pksykyak8vt as ID,
  ID1z61wlmtvxrjn as ID_0,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  CareLocationClosure1da03s5ze3kft as CareLocationClosure,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_location1p3um6ao7ento as get_location,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_location5qvftw9oaw3d as get_location_0,
  get_date13hdmf8teioql as get_date,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  overlaps2e3dna24gi3hb as overlaps,
  insideoec66sredh4u as inside,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { and3dbt2f202um49 as and } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconTextButton3p26faj7s7pcp as iconTextButton,
} from '../components/view-utilities.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  get_H3Semantic2xvwj5aimpbn as get_H3Semantic,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance,
  LabeledViewseav57tyecmf as LabeledView,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { attendanceGrida6fmjgaehija as attendanceGrid } from './attendanceGrid.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { styledHeaderwng1nfqibdig as styledHeader } from '../../theme/semantics.mjs';
import { colOfv2oygjkn5hb2 as colOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function AttendancePeriodDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendancePeriodLabel_4v4nxb_k$();
}
function AttendancePeriodDetailPage$render$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceChildrenScheduledLabel_ceetoo_k$();
}
function AttendancePeriodDetailPage$render$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusLabel_3q3usw_k$();
}
function AttendancePeriodDetailPage$render$lambda_2($this$iconTextButton) {
  return 'Attendance Sheet';
}
function AttendancePeriodDetailPage$render$lambda$slambda(this$0, $this_iconTextButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.period_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var csv = yield* attendanceSheetCsv(tmp, listOf(tmp$ret$1), false, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.location_1;
    var tmp0 = (yield* await_0(this_2, $completion)).name_1;
    // Inline function 'kotlin.text.replace' call
    var locationName = Regex().new_kotlin_text_Regex_acuq4a_k$('[^a-zA-Z0-9]+').replace_1ix0wf_k$(tmp0, '-');
    var tmp_0 = $this_iconTextButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.period_1;
    var tmp$ret$4 = yield* await_0(this_3, $completion);
    yield* download(tmp_0, 'attendance-' + locationName + '-' + tmp$ret$4.period_1.start_1.toString() + '.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function AttendancePeriodDetailPage$render$lambda_3($this$iconTextButton) {
  return 'Blank Sheet';
}
function AttendancePeriodDetailPage$render$lambda$slambda_0(this$0, $this_iconTextButton) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.period_1;
    var tmp$ret$1 = yield* await_0(this_1, $completion);
    var csv = yield* attendanceSheetCsv(tmp, listOf(tmp$ret$1), true, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.location_1;
    var tmp0 = (yield* await_0(this_2, $completion)).name_1;
    // Inline function 'kotlin.text.replace' call
    var locationName = Regex().new_kotlin_text_Regex_acuq4a_k$('[^a-zA-Z0-9]+').replace_1ix0wf_k$(tmp0, '-');
    var tmp_0 = $this_iconTextButton.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.period_1;
    var tmp$ret$4 = yield* await_0(this_3, $completion);
    yield* download(tmp_0, 'attendance-blank-' + locationName + '-' + tmp$ret$4.period_1.start_1.toString() + '.csv', toBlob(csv, 'text/csv'), VOID, $completion);
    return Unit_instance;
  }), 1);
}
function AttendancePeriodDetailPage$render$lambda_4($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceClosuresHeading_1l8eiw_k$();
}
function AttendancePeriodDetailPage$render$lambda_5($this$colOf, closure) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($this$colOf.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$colOf.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  var this_0 = get_bold(element);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => renderToString($this$invoke.invoke_r7m7el_k$(closure).date_1, RenderSize_Abbreviation_getInstance()));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element.willAddChild_hz2iwc_k$(element_1);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(closure).reason_1.displayName_1 + ' \xB7 ' + ($this$invoke.invoke_r7m7el_k$(closure).reason_1.paid_1 ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closurePaidLabel_brac2y_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_closureUnpaidLabel_5pnjh9_k$()));
  element_1.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  $this$colOf.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function AttendancePeriodDetailPage$render$lambda_6($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var AttendancePeriodDetailPageClass;
function AttendancePeriodDetailPage() {
  if (AttendancePeriodDetailPageClass === VOID) {
    class $ {
      constructor(id) {
        this.id_1 = id;
        var tmp = this;
        tmp.period_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_locationAttendancePeriods_kbvlcb_k$().get_6ueaa7_k$(new (ID())(this.id_1))));
        var tmp_0 = this;
        tmp_0.location_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.awaitNotNull_2lqt5h_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_0())($this$remember.invoke_r7m7el_k$(this.period_1).location_1))));
        var tmp_1 = this;
        tmp_1.placements_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_childrenPlacement_hazabn_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$2);
          var tmp$ret$0 = and(eq(get_location(it), new (ID_0())($this$remember.invoke_r7m7el_k$(this.period_1).location_1)), overlaps(get_activeRange(it), $this$remember.invoke_r7m7el_k$(this.period_1).period_1));
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp$ret$0)));
        });
        var tmp_2 = this;
        tmp_2.closures_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocationClosures_im9skn_k$();
          // Inline function 'com.lightningkite.services.database.Query' call
          // Inline function 'kotlin.collections.listOf' call
          var orderBy = emptyList();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(CareLocationClosure()), arrayOf([]), false));
          var tmp$ret$8 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$8);
          var tmp$ret$9 = and(eq(get_location_0(it), new (ID_0())($this$remember.invoke_r7m7el_k$(this.period_1).location_1)), inside(get_date(it), $this$remember.invoke_r7m7el_k$(this.period_1).period_1));
          var tmp$ret$5 = new (Query())(tmp$ret$9, orderBy, 0, 100);
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$5));
        });
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendancePeriodPageTitle_p6ycjf_k$($this$remember.invoke_r7m7el_k$(this.period_1).period_1.toString()));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.fullWidthPage' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_1 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_2 = weight(this_1, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.get_title_iz32un_k$()));
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_3 = themed(element, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_3.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_4 = get_centered(element_2);
        var tmp$ret$21 = weight(this_4, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = themed(tmp$ret$21, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.h3' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.set_themeChoice_py59um_k$(element_4.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H3Semantic())));
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
        element_4.invoke_bnq13k_k$(tmp_4, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendanceLocationLabel_w7cjz0_k$($this$invoke.invoke_r7m7el_k$(this.location_1).name_1));
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        element_3.willAddChild_hz2iwc_k$(element_5);
        var tmp_5 = KMutableProperty0();
        var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_7, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendanceProviderLabel_uwtfq8_k$($this$invoke.invoke_r7m7el_k$(this.location_1).providerName_1));
        element_5.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_5);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_2);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_7 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_7.willAddChild_hz2iwc_k$(element_6);
        var tmp_8 = KMutableProperty0();
        var tmp_9 = LabeledView$_get_content_$ref_5yojet(element_6);
        var tmp_10 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, LabeledView$_set_content_$ref_ys1c8f(element_6));
        element_6.invoke_bnq13k_k$(tmp_10, AttendancePeriodDetailPage$render$lambda);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element_6.willAddChild_hz2iwc_k$(element_7);
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl(element_7);
        var tmp_13 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb(element_7));
        element_7.invoke_bnq13k_k$(tmp_13, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).attendancePeriodRange_42l3v7_k$(renderToString($this$invoke.invoke_r7m7el_k$(this.period_1).period_1.start_1, RenderSize_Abbreviation_getInstance()), renderToString($this$invoke.invoke_r7m7el_k$(this.period_1).period_1.endInclusive_1, RenderSize_Abbreviation_getInstance())));
        element_7.onStartup_vrxh3i_k$();
        element_6.addChild_2qpft2_k$(element_7);
        element_6.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_8 = get_centered(element_2);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_9 = weight(this_8, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_9.willAddChild_hz2iwc_k$(element_8);
        var tmp_14 = KMutableProperty0();
        var tmp_15 = LabeledView$_get_content_$ref_5yojet(element_8);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, LabeledView$_set_content_$ref_ys1c8f(element_8));
        element_8.invoke_bnq13k_k$(tmp_16, AttendancePeriodDetailPage$render$lambda_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (TextView())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        var tmp_17 = KMutableProperty0();
        var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_9);
        var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_9));
        element_9.invoke_bnq13k_k$(tmp_19, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.placements_1).get_size_woubt6_k$().toString());
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        element_8.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_10 = get_centered(element_2);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_11 = weight(this_10, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_11.willAddChild_hz2iwc_k$(element_10);
        var tmp_20 = KMutableProperty0();
        var tmp_21 = LabeledView$_get_content_$ref_5yojet(element_10);
        var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, LabeledView$_set_content_$ref_ys1c8f(element_10));
        element_10.invoke_bnq13k_k$(tmp_22, AttendancePeriodDetailPage$render$lambda_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (TextView())(element_10.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        element_10.willAddChild_hz2iwc_k$(element_11);
        var tmp_23 = KMutableProperty0();
        var tmp_24 = TextView$_get_content_$ref_4pzcwl(element_11);
        var tmp_25 = getPropertyCallableRef('content', 0, tmp_23, tmp_24, TextView$_set_content_$ref_pketfb(element_11));
        element_11.invoke_bnq13k_k$(tmp_25, ($this$invoke) => !($this$invoke.invoke_r7m7el_k$(this.period_1).submitted_1 == null) ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusSubmitted_swmv6f_k$() : $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_attendanceStatusOpen_y91qpa_k$());
        element_11.onStartup_vrxh3i_k$();
        element_10.addChild_2qpft2_k$(element_11);
        element_10.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_10);
        var tmp_26 = get_centered(element_2);
        var tmp_27 = AttendancePeriodDetailPage$render$lambda_2;
        var tmp_28 = Companion_getInstance_0().download_1;
        iconTextButton(tmp_26, tmp_27, tmp_28, ($this$iconTextButton) => {
          $this$iconTextButton.set_action_2ds022_k$(Action('Export attendance sheet', VOID, VOID, VOID, VOID, VOID, AttendancePeriodDetailPage$render$lambda$slambda(this, $this$iconTextButton)));
          return Unit_instance;
        });
        var tmp_29 = get_centered(element_2);
        var tmp_30 = AttendancePeriodDetailPage$render$lambda_3;
        var tmp_31 = Companion_getInstance_0().download_1;
        iconTextButton(tmp_29, tmp_30, tmp_31, ($this$iconTextButton) => {
          $this$iconTextButton.set_action_2ds022_k$(Action('Export blank attendance sheet', VOID, VOID, VOID, VOID, VOID, AttendancePeriodDetailPage$render$lambda$slambda_0(this, $this$iconTextButton)));
          return Unit_instance;
        });
        element_2.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_2);
        attendanceGrid(element, this.period_1, this.closures_1, this.placements_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (Space())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element.willAddChild_hz2iwc_k$(element_12);
        element_12.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$shownWhen.invoke_r7m7el_k$(this.closures_1).isEmpty_y1axqb_k$();
        });
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_12.willAddChild_hz2iwc_k$(element_13);
        element_13.set_vertical_nuap32_k$(true);
        styledHeader(element_13, AttendancePeriodDetailPage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_13 = themed(element_13, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (RowOrCol())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_13.willAddChild_hz2iwc_k$(element_14);
        element_14.set_vertical_nuap32_k$(true);
        colOf(element_14, this.closures_1, VOID, VOID, VOID, AttendancePeriodDetailPage$render$lambda_5);
        element_14.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_14);
        element_13.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_14 = shownWhen(element, VOID, VOID, AttendancePeriodDetailPage$render$lambda_6);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Space())(this_14.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_15);
        this_14.willAddChild_hz2iwc_k$(element_15);
        element_15.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_15);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'AttendancePeriodDetailPage', VOID, VOID, [Page()]);
    AttendancePeriodDetailPageClass = $;
  }
  return AttendancePeriodDetailPageClass;
}
//region block: exports
export {
  AttendancePeriodDetailPage as AttendancePeriodDetailPage2fnxdkx3t2m6k,
};
//endregion

//# sourceMappingURL=AttendancePeriodDetailPage.mjs.map
